import Cookies from 'js-cookie';

import { trackV2 } from '@gumtree/shell/src/common/common-actions';
import {
    PermutiveEventNames,
    trackPermutiveCustomEvent,
} from '@gumtree/shared/src/util/permutive/track-event';

import { redirectToUrl } from '@gumtree/ui-library/src/utils/browser-service';
import { trackGA4Event } from '@gumtree/shared/src/util/ga4-shared';
import fetchReveal from '@gumtree/vip/src/get-data/fetch/fetch-reveal';

export const COOKIE_EXPIRY_TIME = 1 / 48; // 15 minutes from now

export const trySetCookiePhoneRevealBegin = (
    userLoggedIn,
    advertId,
    showRevealNumber,
    isLoginRequiredToContactForVipCategory,
    domain
) => {
    if (
        userLoggedIn === false &&
        showRevealNumber === false &&
        isLoginRequiredToContactForVipCategory === true
    ) {
        Cookies.set(`R2SPhoneBegin_${advertId}`, 'R2SPhoneBegin', {
            domain,
            expires: COOKIE_EXPIRY_TIME,
        });
    }
};

// advertId: number;
// revealSellerTelephoneNumberToken: string;
// shouldPhoneRevealBeginFunc: () => void;
// redirectToApp: string;
// isFromMotorsFeed: boolean;
export const revealNumberThunk = async ({
        advertId,
        revealSellerTelephoneNumberToken,
        shouldPhoneRevealBeginFunc,
        redirectToApp,
        isFromMotorsFeed,
        trackEventPayload,
    }) => {
        const response = await fetchReveal({
            advertId,
            revealSellerTelephoneNumberToken,
            redirectToApp,
        });

        if (response) {
            if (response.status === 401) {
                const loc = response.headers.get('Location');
                shouldPhoneRevealBeginFunc();
                loc && redirectToUrl(loc);
            } else if (response.status === 200) {
                const { data, expired, valid } = await response.json();

                if (redirectToApp) {
                    // tracking event for telephone or sms event
                    const eventName =
                        redirectToApp === 'tel'
                            ? PermutiveEventNames.R2S_PHONE_BEGIN
                            : PermutiveEventNames.R2S_SMS_BEGIN;
                    trackPermutiveCustomEvent(window, eventName, {});

                    trackGA4Event<GA4.ContactSellerClickEvent>({
                        event: 'contact_a_seller',
                        contactASellerMethod:
                            redirectToApp === 'tel' ? 'click phone number' : 'click sms',
                        formValidation: 'success',
                        listingPartner: isFromMotorsFeed ? 'motors' : undefined,
                        listingDetails: trackEventPayload,
                    });

                    redirectToUrl(`${redirectToApp}:${data}`);
                } else {
                    // tracking for revealing the phone number
                    const eventName = 'R2SPhoneRevealSuccess';
                    trackV2(eventName);
                    trackPermutiveCustomEvent(
                        window,
                        PermutiveEventNames.R2S_PHONE_REVEAL_SUCCESS,
                        {}
                    );

                    trackGA4Event({
                        event: 'contact_a_seller',
                        contactASellerMethod: 'click to reveal phone number',
                        formValidation: 'success',
                        listingPartner: isFromMotorsFeed ? 'motors' : undefined,
                        listingDetails: trackEventPayload,
                    });
                }

                return { data, expired, valid }
            }
        }
        return {};
    }

interface Params {
    e?: React.MouseEvent | null,
    
    // 以下来自 sellerContactDetails
    revealSellerTelephoneNumberToken?: string;
    userLoggedIn?: boolean;
    showRevealNumber?: boolean;
    isLoginRequiredToContactForVipCategory?: boolean;

    // 以下来自 adDetails
    id: string;
    isFromMotorsFeed?: boolean;

    // 以下来自 baseConfig
    domain: string;
    redirectToApp?: string;

    trackEventPayload;
}

export const revealPhoneUtil = async (params: Params) => {
    const {
        e,
        
        // 以下来自 sellerContactDetails
        revealSellerTelephoneNumberToken,
        userLoggedIn,
        showRevealNumber,
        isLoginRequiredToContactForVipCategory,
    
        // 以下来自 adDetails
        id, 
        isFromMotorsFeed,
    
        // 以下来自 baseConfig
        domain,
        redirectToApp = '',

        trackEventPayload,
    } = params

    e?.preventDefault();

    const shouldPhoneRevealBeginFunc = () =>
        trySetCookiePhoneRevealBegin(
            userLoggedIn,
            id,
            showRevealNumber,
            isLoginRequiredToContactForVipCategory,
            domain
        );

    const res = await revealNumberThunk({
        advertId: id,
        revealSellerTelephoneNumberToken,
        shouldPhoneRevealBeginFunc,
        redirectToApp,
        isFromMotorsFeed,
        trackEventPayload,
    })
    //  mock data
    //  return {
    //     data: '01234567890',
    //     expired: false,
    //     valid: true,
    //  }
    return res;
}
